import React, { Component } from 'react';
import { graphql } from 'react-relay';
import DistributionBarChart from '../../../../components/DistributionBarChart';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';

@withReportFilterProps
@withWidgetData(
  graphql`
    query DistributionWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
    ) {
      widget(id: $widgetId) {
        id
        mongoId
        name
        config {
          subtitle
          hideHeader
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
            ) {
              count
              ...DistributionBarChart_answersReport
            }
            ...DistributionBarChart_question
          }
          useNumbers
        }
      }
    }
  `,
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter()
class DistributionWidget extends Component {
  render() {
    const widget = this.props.widget;
    const question = widget.config.question;
    return (
      <DistributionBarChart
        question={question}
        answersReport={question.answersReport}
        height={this.props.bodyHeight}
        width={this.props.width}
        colorBars={true}
        uniqueId={widget.id}
        widgetConfig={widget.config || {}}
      />
    );
  }
}

export default DistributionWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/DistributionWidget/DistributionWidget.js